import { Component, ViewChild, Injector, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { AppComponentBase } from '@shared/common/app-component-base';
import { SurveysServiceProxy } from '@shared/service-proxies/service-proxies';
import { FileDownloadService } from '@shared/utils/file-download.service';
import * as moment from 'moment';


@Component({
    selector: 'qrCodeModal',
    templateUrl: './qrcode-modal.component.html'
})

export class QrCodeModalComponent extends AppComponentBase {

    @ViewChild('qrCodeModal') modal: ModalDirective;

    active = false;
    saving = false;
    widthNumber = undefined;
    heigthNumber = undefined;
    id: number = undefined;
    title: string = '';

    constructor(
        injector: Injector,
        private _surveysServiceProxy: SurveysServiceProxy,
        private _fileDownloadService: FileDownloadService
    ) {
        super(injector);
    }

    ngAfterViewChecked(): void {

        //Temporary fix for: https://github.com/valor-software/ngx-bootstrap/issues/1508
        $('tabset ul.nav').addClass('m-tabs-line');
        $('tabset ul.nav li a.nav-link').addClass('m-tabs__link');

        //Ajuste para melhorar performance da modal
        this.modal.config.animated = false;
        this.modal.config.backdrop = 'static';
    }

    onShown() {

    }

    public show(surveyId?: number, title?: string): void {

        this.id = surveyId;
        this.title = title;
        this.active = true;
        this.widthNumber = 200;
        this.heigthNumber = 200;
        this.modal.show();
    }

    close(): void {
        this.active = false;
        this.id = undefined;
        this.widthNumber = 0;
        this.heigthNumber = 0;
        this.saving = false;
        this.modal.hide();
    }

    getQrCode() {
        this.saving = true;
        this._surveysServiceProxy.getQrCode(this.id, this.widthNumber, this.heigthNumber)
            .subscribe(result => {
                this.saving = false;
                this._fileDownloadService.downloadTempFile(result);
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/event/surveys/modals/qrcode-modal.component.ts